import { FolderId } from 'modules/domains/foldering';
import {
  CopyTemplateProps,
  CopyTemplateResponseProps,
  CreateTemplateProps,
  GetMessageTypesAndSendersProps,
  GetMessageTypesAndSendersResponseProps,
} from '../types';
import * as t from './actionTypes';

// CREATE TEMPLATE
export const createTemplate = ({
  currentFolderId,
  dragDropSlug,
  messageMedium,
  name,
  defaultLocale,
  templateType,
  placementId,
}: CreateTemplateProps) => ({
  type: t.CREATE_TEMPLATE_REQUEST,
  currentFolderId,
  defaultLocale,
  dragDropSlug,
  messageMedium,
  name,
  templateType,
  placementId,
});

export const createTemplateResponse = (templateId: number, messageMedium: string) => ({
  type: t.CREATE_TEMPLATE_RESPONSE,
  templateId,
  messageMedium,
});

// COPY TEMPLATE
export const copyTemplate = (copyTemplateProps: CopyTemplateProps) => ({
  type: t.COPY_TEMPLATE_REQUEST,
  ...copyTemplateProps,
});

export const copyTemplateResponse = ({
  srcTemplateId,
  destTemplateId,
  destProjectId,
  triggeredBy,
}: CopyTemplateResponseProps) => ({
  type: t.COPY_TEMPLATE_RESPONSE,
  srcTemplateId,
  destTemplateId,
  destProjectId,
  triggeredBy,
});

// get message types and senders
export const getMessageTypesAndSenders = ({
  projectId,
  messageMedium,
}: GetMessageTypesAndSendersProps) => ({
  type: t.GET_MESSAGETYPES_AND_SENDERS_REQUEST,
  projectId,
  messageMedium,
});

export const getMessageTypesAndSendersResponse = (
  getMessageTypesAndSendersResponseProps: GetMessageTypesAndSendersResponseProps,
) => ({
  type: t.GET_MESSAGETYPES_AND_SENDERS_RESPONSE,
  ...getMessageTypesAndSendersResponseProps,
});

export const getMessageTypesAndSendersError = () => ({
  type: t.GET_MESSAGETYPES_AND_SENDERS_ERROR,
});

// DELETE TEMPLATE
export const deleteTemplates = (
  templateIds: Array<number>,
  refetch: () => void,
  triggeredBy?: string,
) => ({
  type: t.DELETE_TEMPLATES_REQUEST,
  templateIds,
  refetch,
  triggeredBy,
});

export const deleteTemplatesResponse = (templateIds: Array<number>, triggeredBy: string) => ({
  type: t.DELETE_TEMPLATES_RESPONSE,
  templateIds,
  triggeredBy,
});

// GET TEMPLATE PREVIEW THUMBNAILS
export const getTemplatePreviewThumbnailsRequest = (templateIds: Array<number>) => ({
  type: t.GET_TEMPLATE_PREVIEW_THUMBNAILS_REQUEST,
  templateIds,
});

export const getTemplatePreviewThumbnailsResponse = (result: any) => ({
  type: t.GET_TEMPLATE_PREVIEW_THUMBNAILS_RESPONSE,
  result,
});

// EXPORT TEMPLATE HTML
export const exportTemplateHTMLRequest = (
  templateId: string | number,
  projectName: string,
  triggeredBy?: string,
) => ({
  type: t.EXPORT_TEMPLATE_HTML_REQUEST,
  templateId,
  projectName,
  triggeredBy,
});

export const exportTemplateHTMLResponse = (templateId: number, triggeredBy: string) => ({
  type: t.EXPORT_TEMPLATE_HTML_RESPONSE,
  templateId,
  triggeredBy,
});

// FETCH ROOT FOLDER INFORMATION
export const fetchRootFolderIdResponse = (rootFolderId: FolderId) => ({
  type: t.FETCH_ROOT_FOLDER_ID_RESPONSE,
  rootFolderId,
});

export const isTemplateAsyncProcessing = (isAsyncProcessing: boolean) => ({
  type: t.IS_TEMPLATE_ASYNC_PROCESSING,
  isAsyncProcessing,
});
